export default __webpack_public_path__ + "static/media/P_wdt_c_cap_1.5f5ab477.mp3";